import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ManualEventType } from '../../model/manual-event';
import { ManualEventService } from '../../services/manualEventService';
import { CarehomeSettingsService } from '../../services/carehome-settings.service';
import { ToastService } from '../../services/toast.service';
import { ErrorService } from '../../services/error.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'app-manual-events-modal',
	templateUrl: './manual-events-modal.component.html',
	styleUrls: ['./manual-events-modal.component.scss']
})
export class ManualEventsModalComponent implements OnInit {
	@Input() residentId: string;
	@Input() residentName: string;
	@Input() modalId: string = 'manual-event-modal';
	@Output() eventSaved = new EventEmitter<void>();

	selectedManualEvent: number | null = null;
	enabledManualEventTypes: ManualEventType[] = [];
	dropdownOptions: any[] = [];
	isSaving: boolean = false;
	manualEventDisplayField = 'en'; // Default to English, will be set based on current language

	constructor(
		private manualEventService: ManualEventService,
		private settingsService: CarehomeSettingsService,
		private toastService: ToastService,
		private errorService: ErrorService,
		private translate: TranslateService
	) {}

	ngOnInit() {
		this.manualEventDisplayField = this.translate.currentLang;
		this.getEnabledManualEventTypes();
	}

	getEnabledManualEventTypes() {
		this.settingsService.getCarehomeSettings()
			.subscribe(settings => {
				this.enabledManualEventTypes = settings.ManualEventTypes;
				this.dropdownOptions = this.enabledManualEventTypes.map(eventType => ({
					id: eventType.id,
					displayText: eventType[this.manualEventDisplayField],
					iconUrl: eventType.iconUrl
				}));
			}, error => {
				console.error('Failed to load manual event types:', error);
				this.errorService.handleError(error);
			});
	}

	open() {
		this.selectedManualEvent = null;
		this.isSaving = false;

		const modalElement = document.getElementById(this.modalId);
		if (modalElement) {
			const modal = new (window as any).bootstrap.Modal(modalElement);
			modal.show();
		}
	}

	close() {
		this.selectedManualEvent = null;
		this.isSaving = false;

		const modalElement = document.getElementById(this.modalId);
		if (modalElement) {
			const modal = (window as any).bootstrap.Modal.getInstance(modalElement);
			if (modal) {
				modal.hide();
			}
		}
	}

	save() {
		if (!this.selectedManualEvent || !this.residentId) {
			return;
		}

		const selectedEventType = this.enabledManualEventTypes.find(
			event => event.id === Number(this.selectedManualEvent)
		);

		if (!selectedEventType) {
			console.error('Invalid manual event type selected');
			return;
		}

		this.isSaving = true;

		this.manualEventService.submitManualEvent(
			this.residentId,
			selectedEventType.id
		).subscribe(
			() => {
				const successMessage = this.translate.instant('manualEvent.success');
				const title = this.translate.instant('manualEvent.title');
				this.toastService.success(successMessage, title, 3000);

				this.close();
				this.eventSaved.emit();
			},
			error => {
				console.error('Failed to save manual event:', error);

				const errorMessage = this.translate.instant('manualEvent.error');
				const title = this.translate.instant('manualEvent.title');
				this.toastService.error(errorMessage, title, 5000);

				this.errorService.handleError(error);
				this.isSaving = false;
			}
		);
	}
}
